export default "__VITE_ASSET__9cr87O4T__"